import { memoize, orderBy } from "lodash";
import { observable, runInAction } from "mobx";
import { reduce } from "et3-type-guards";

import { apiCallGetWatchAlertsData } from "../../../api/developer-api/api-call-get-watch-alert-data";
import { TWatchAlertsData } from "../../../Types";
import getCorePopUpStore from "../../core/core-popup-store";
import getCoreUIStore from "../../core/core-ui-store";

class WatchAlertsStore {
  watchAlertsData = observable.box<TWatchAlertsData>([]);
  showWatchAlerts = observable.box<boolean>(false);

  newUsersAlerts = observable.box<number[]>([]);
  fbUsersAlerts = observable.box<number[]>([]);
  emailUsersAlerts = observable.box<number[]>([]);
  smsUsersAlerts = observable.box<number[]>([]);
  iosPaymentsAlerts = observable.box<number[]>([]);
  androidPaymentsAlerts = observable.box<number[]>([]);
  hyperpayIosPaymentsAlerts = observable.box<number[]>([]);
  hyperpayAndroidPaymentsAlerts = observable.box<number[]>([]);
  lastLoginUsersAlerts = observable.box<number[]>([]);
  arrayXAxis = observable.box<string[]>([]);

  setWatchAlertsData = (data: TWatchAlertsData) => {
    runInAction(() => {
      const sortedData = orderBy(data, "id", "asc");
      this.watchAlertsData.set(sortedData);
      this.showWatchAlerts.set(true);
    });
  };
  getWatchAlertsFromDatabase = async () => {
    getCoreUIStore().setIsLoading("DEVELOPER_WATCH_ALERT", true);
    const { status, data, code } = await apiCallGetWatchAlertsData();
    getCoreUIStore().setIsLoading("DEVELOPER_WATCH_ALERT", false);
    if (status === "OK") {
      this.setWatchAlertsData(data);
    } else {
      getCorePopUpStore().showAlertMessage(code);
    }
  };
  getAlerts = async () => {
    await this.getWatchAlertsFromDatabase();
    const watchAlertsData = this.watchAlertsData.get();
    this.newUsersAlerts.set(
      watchAlertsData.map((e) => {
        return e.newUsers;
      })
    );
    this.fbUsersAlerts.set(
      watchAlertsData.map((e) => {
        return e.fbUsers;
      })
    );
    this.emailUsersAlerts.set(
      watchAlertsData.map((e) => {
        return e.emailUsers;
      })
    );
    this.smsUsersAlerts.set(
      watchAlertsData.map((e) => {
        return e.smsUsers;
      })
    );
    this.iosPaymentsAlerts.set(
      watchAlertsData.map((e) => {
        return e.iosPayments;
      })
    );
    this.androidPaymentsAlerts.set(
      watchAlertsData.map((e) => {
        return e.androidPayments;
      })
    );
    this.hyperpayIosPaymentsAlerts.set(
      watchAlertsData.map((e) => {
        return reduce(() => e.hyperpayIosPayments, 0);
      })
    );
    this.hyperpayAndroidPaymentsAlerts.set(
      watchAlertsData.map((e) => {
        return reduce(() => e.hyperpayAndroidPayments, 0);
      })
    );
    this.lastLoginUsersAlerts.set(
      watchAlertsData.map((e) => {
        return e.lastLoginUsers;
      })
    );
    this.arrayXAxis.set(
      watchAlertsData.map((e) => {
        return e.alertDate;
      })
    );
  };
}
const getWatchAlertsStore = memoize(
  () => new WatchAlertsStore(),
  () => 1
);
export default getWatchAlertsStore;
